/**
 * Asynchronously loads the component for PiecripCopyTradePage
 */

import { lazyLoad } from '@utils/loadable';

export const PiecripCopyTradePage = lazyLoad(
  () => import('./index'),
  (module) => module.PiecripCopyTradePage
);
